import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["COMPANY_ADMIN"] = "COMPANY_ADMIN";
    UserRole["USER"] = "USER";
})(UserRole || (UserRole = {}));
export var AccessLevel;
(function (AccessLevel) {
    AccessLevel["CREATE"] = "CREATE";
    AccessLevel["READ_ONLY"] = "READ_ONLY";
})(AccessLevel || (AccessLevel = {}));
export var Role;
(function (Role) {
    Role["ADVERTISER"] = "ADVERTISER";
    Role["AGENCY"] = "AGENCY";
    Role["BROKER"] = "BROKER";
    Role["OTHER"] = "OTHER";
    Role["PUBLISHER"] = "PUBLISHER";
})(Role || (Role = {}));
export var Restriction;
(function (Restriction) {
    Restriction["POSTNETZ_BRANCH_USER_RESTRICTION"] = "POSTNETZ_BRANCH_USER_RESTRICTION";
    Restriction["READ_ONLY_POSTNETZ_BRANCH_USER_RESTRICTION"] = "READ_ONLY_POSTNETZ_BRANCH_USER_RESTRICTION";
})(Restriction || (Restriction = {}));
